(function userGuideMobMenu() {
    const $mobBtn = $('.js-mob-btn');

    $mobBtn.on('click', function () {
        $(this).toggleClass('toggled');
        $('body').toggleClass('guide-menu-toggled');
    });

    $('.js-tabs-box a').on('click', function () {
        $mobBtn.removeClass('toggled');
        $('body').removeClass('guide-menu-toggled');
    });
})();

(function sidebarLang() {
    $('.js-lang-btn').on('click', function () {
        $(this).parents('.js-dropdown').toggleClass('show');
    });

    $('body').on('click', function (event) {
        if (!$(event.target).hasClass('js-lang-btn')) {
            const $langDropdown = $('.js-dropdown');
            $langDropdown.removeClass('show');
        }
    });
})();

(function userGuideOpenSubMenuBeforeLoadPage() {
    let currentUrl = window.location.origin + window.location.pathname;
    $('.sidebar-link').each(function () {
        let $this = jQuery(this);

        if ($this.attr('href') === currentUrl) {
            $this.next('.sub-box').css('display', 'block');
            $this.parents('.sidebar-item').addClass('open');
            $this.replaceWith('<div class="sidebar-link js-collapse">' + $(this).html() + '</div>');
        }

    });
})();

(function sidebarCollapse() {

    function collapseItems(wrapList, navItem, navLink) {
        jQuery(navItem + ' ' + navLink).on('click', function () {
            $(this).parents(wrapList).find('.js-collapse-box:visible').slideUp();
            $(this).parents('.js-sidebar-item').children('.js-collapse-box:hidden').slideDown();
            $(this).parents(navItem).siblings(navItem).removeClass('open');

            if ($(this).parents(navItem + '.js-sidebar-item').hasClass('open')) {
                if (navItem !== '.sidebar-item') {
                    $(this).parents(navItem + '.js-sidebar-item').toggleClass('open');
                }
            } else {
                $(this).parents(navItem + '.js-sidebar-item').addClass('open');
            }
        });
    }

    collapseItems('.sidebar-list', '.sidebar-item', '.sidebar-link');
    collapseItems('.sub-box-in', '.sub-item', '.sidebar-sub-link');
    collapseItems('.third-box-in', '.third-item', '.sidebar-third-link');
})();

(function userGuideTabs() {
    $('body').on('click', '.js-tab:not(.active)', function () {
        const tabContentId = $(this).attr('data-bs-target');
        $('.js-tabs-box').find('.js-tab').removeClass('active');
        $('.js-tabs-box').find('.js-tab[data-bs-target=' + tabContentId + ']').addClass('active');
        $('[data-tab=' + tabContentId + ']').addClass('active').siblings('.js-tab-content').removeClass('active');
        // to activate lazyload:
        $(window).trigger('scroll');
    });
})()

jQuery(function ($) {
    let dataUserGuide = {}

    $('.btn-search').on('click', function (event) {
        event.preventDefault();

        const searchMain = $(this).closest('.search-main');
        searchMain.addClass('active');

        dataUserGuide.searchTerm = $.trim($('.search-input').val());
        dataUserGuide.postType = $(this).data('post-type');

        window.dataLayer = window.dataLayer || [];

        if (dataUserGuide.searchTerm.length > 1) {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    'action': 'ajax_search',
                    'user-guide-search': JSON.stringify(dataUserGuide),
                    'paged': 1
                },
                success: function (data) {
                    searchMain.removeClass('active');

                    $('.search-title').text('Search results');
                    $('.guide-body').html(data);

                    let max_chars = 1024;
                    let currentLength = 0;
                    let textareaLimit = $('.js-textarea textarea');

                    let contactForm = jQuery('.wpcf7-form');
                    wpcf7.init(contactForm[0]);

                    textareaLimit.on('keydown', function (e) {
                        if ($(this).val().length >= max_chars) {
                            $(this).val($(this).val().substr(0, max_chars));
                        }
                    });

                    textareaLimit.on('keyup', function (e) {

                        if ($(this).val().length >= max_chars) {
                            $(this).val($(this).val().substr(0, max_chars));
                        }

                        currentLength = $(this).val().length;

                        $('.js-max-val').html(max_chars - currentLength);
                    });

                    let eventAction = $('.results-body').length > 0 ? 'Search Complete' : 'Site Empty Search';

                    window.dataLayer.push(
                        {
                            'event': 'search_complete',
                            'searchTerm': dataUserGuide.searchTerm
                        }
                    );

                    if (eventAction === 'Site Empty Search') {
                        window.dataLayer.push(
                            {
                                'event': 'EOSCOM',
                                'eventCategory': 'EosComEvents',
                                'eventAction': eventAction,
                                'eventLabel': dataUserGuide.searchTerm
                            }
                        );
                    }
                }
            });
        } else {
            searchMain.removeClass('active');
        }
    });

    $('.guide-content').on('click', '.user-guide-pagination-item', function () {
        $('.user-guide-pagination-item').removeClass('active');
        $(this).addClass('active');
        $('.user-guide-pagination').addClass('active');

        let pageNumb = $(this).data('number-page');

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: {
                'action': 'ajax_search',
                'user-guide-search': JSON.stringify(dataUserGuide),
                'paged': pageNumb
            },
            success: function (data) {
                $('.guide-body').html(data);
                $(this).addClass('active');
            }
        })
    });
});